<template>
  <v-card class="media-manager-gallery">
    <v-card-title class="px-8 pt-6">
      {{ $t('media.media_manager_title') }}
    </v-card-title>

    <v-divider />

    <v-card-text v-if="images.length > 0" class="ma-0 pa-0 d-flex content">
      <Thumbnails
        :allowMultipleSelect="allowMultipleSelect"
        :canAdd="canAdd && !isUploading"
        :images="images"
        :readOnly="readOnly || isUploading"
        :selectedImageIndex="selectedImageIndex"
        @added="$emit('added', $event)"
        @selected="$emit('selected', $event)"
      />

      <Preview
        v-if="selectedImage"
        :image="selectedImage"
        :readOnly="readOnly || isUploading"
        @delete="$emit('delete')"
        @edit="$emit('edit', selectedImageIndex)"
      />
    </v-card-text>

    <v-card-text v-if="images.length === 0">
      <EmptyState
        :allowMultipleSelect="allowMultipleSelect"
        @added="$emit('added', $event)"
      />
    </v-card-text>

    <v-divider />

    <v-card-actions class="justify-end ma-0 px-8 py-6">
      <Button
        class="me-2"
        plain
        color="grey"
        :disabled="isUploading"
        :text="$t('common.button.close')"
        @click="$emit('close')"
      />

      <Button
        v-if="canSave"
        class="me-2"
        color="primary"
        :loading="isUploading"
        :text="$t('common.button.save')"
        @click="$emit('save')"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import { IMAGE_SIZES } from 'rever-media-sdk'

import Thumbnails from './GalleryThumbnails.vue'
import Preview from './GalleryPreview.vue'
import EmptyState from './GalleryEmptyState.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'MediaManagerGallery',

  components: {
    Thumbnails,
    Preview,
    EmptyState,
    Button,
  },

  props: {
    images: {
      type: Array,
      required: true,
    },

    selectedImageIndex: {
      type: Number,
      default: null,
    },

    readOnly: Boolean,

    canAdd: Boolean,

    canSave: Boolean,

    allowMultipleSelect: Boolean,

    isUploading: Boolean,
  },

  data() {
    return {
      IMAGE_SIZES,
    }
  },

  computed: {
    selectedImage() {
      return this.images?.[this.selectedImageIndex] ?? null
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  overflow: hidden !important;
}
.media-manager-gallery {
  max-height: 80vh;
}
</style>
